import React from 'react';

export const ExcelIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    fill="none" 
    viewBox="0 0 20 20"
    {...props}
  >
    <path fill="#185c37" d="M12.244 9.591 5.326 8.372v9.006a.744.744 0 0 0 .746.744h11.937a.74.74 0 0 0 .747-.744V14.06z"/>
    <path fill="#21a366" d="M12.244 1.875H6.072a.744.744 0 0 0-.746.744v3.319L12.244 10l3.663 1.219L18.757 10V5.938z"/>
    <path fill="#107c41" d="M5.326 5.938h6.918V10H5.326z"/>
    <path fill="#000" d="M10.277 5.124h-4.95V15.28h4.95a.75.75 0 0 0 .747-.744V5.868a.75.75 0 0 0-.747-.744" opacity=".1"/>
    <path fill="#000" d="M9.87 5.534H5.327V15.69h4.545a.75.75 0 0 0 .746-.744V6.278a.75.75 0 0 0-.746-.744" opacity=".2"/>
    <path fill="#000" d="M9.87 5.534H5.327v9.344h4.545a.75.75 0 0 0 .746-.745V6.278a.75.75 0 0 0-.746-.744" opacity=".2"/>
    <path fill="#000" d="M9.464 5.534H5.326v9.344h4.138a.75.75 0 0 0 .746-.745V6.278a.75.75 0 0 0-.746-.744" opacity=".2"/>
    <path fill="url(#a)" d="M1.996 5.534h7.462a.746.746 0 0 1 .746.744v7.45a.746.746 0 0 1-.747.743h-7.46a.74.74 0 0 1-.747-.744V6.278a.744.744 0 0 1 .746-.744"/>
    <path fill="#fff" d="m3.568 12.423 1.57-2.428L3.7 7.581h1.155l.784 1.546c.072.146.125.255.149.327h.01a6 6 0 0 1 .163-.34l.839-1.53h1.062l-1.474 2.4 1.512 2.44H6.769l-.906-1.694a1.5 1.5 0 0 1-.107-.228H5.74q-.04.115-.105.22l-.933 1.7z"/>
    <path fill="#33c481" d="M18.006 1.875H12.24v4.063h6.512V2.619a.743.743 0 0 0-.746-.744"/>
    <path fill="#107c41" d="M12.24 10h6.512v4.063H12.24z"/>
    <defs>
      <linearGradient id="a" x1="2.809" x2="8.645" y1="4.949" y2="15.056" gradientUnits="userSpaceOnUse">
        <stop stopColor="#18884f"/>
        <stop offset=".5" stopColor="#117e43"/>
        <stop offset="1" stopColor="#0b6631"/>
      </linearGradient>
    </defs>
  </svg>
);

